import { Controller } from "@hotwired/stimulus"

// VersioniModuli di components/VersioniModuli.js (31a5bd1) con versioni_moduli/_versioni_moduli. Lo stesso controller
// su ogni parte:
// - il frame (non controllato): `trattieni` lascia com'è il frame già caricato quando il pannello si rilegge con morph
//   e indirizzo (progetto, bando, fase, permesso) non cambia, come la key di React; con un altro indirizzo il morph lo
//   riscrive e Turbo lo rilegge; `ripubblica`, dopo il morph del pannello che lo contiene, ripubblica lo stato del frame
//   tenuto (il pannello riletto porta quello calcolato dal server);
// - caricamento, errore ed elenco con `bloccate` (onStato): lo stato va su data-blocked di #application-prep-panel e
//   sul pulsante «Prepara la domanda» (disabled se c'è anche un altro blocco del pannello: data-blocco-pannello);
// - l'errore: `riprova` (carica()) rimostra il caricamento e rilegge il frame;
// - l'elenco controllato con `refreshTarget` (onSaved del chiamante): dopo una scelta riuscita rilegge quel
//   turbo-frame. Lo fa `salvata` su turbo:before-fetch-response, non `fine` su turbo:submit-end: la scheda è il form e
//   lo stream la sostituisce, un submit-end del form staccato non arriverebbe più al controller (task 23/33);
// - l'elenco: per ogni scheda (form) «Salva scelta» disabilitato con una versione scelta e motivo o fonte sotto i 10
//   caratteri; durante l'invio campi fermi e l'errore precedente tolto (setErrore("")), «Salvataggio…» è di Turbo
//   (data-turbo-submits-with).
export default class extends Controller {
  static values = { bloccate: Boolean, refreshTarget: String }
  static targets = ["caricamento"]

  connect() {
    if (this.hasBloccateValue) this.#pubblica(this.bloccateValue)
    this.element.querySelectorAll("form").forEach((form) => this.#aggiornaForm(form))
  }

  trattieni(event) {
    if (event.target !== this.element) return
    const nuovo = event.detail?.newElement
    if (nuovo && this.#stessoIndirizzo(nuovo.getAttribute("src"), this.element.getAttribute("src"))) event.preventDefault()
  }

  ripubblica(event) {
    const pannello = this.element.closest("#application-prep-panel")
    if (!pannello || event.target !== pannello) return
    const stato = this.element.querySelector("[data-versioni-moduli-bloccate-value]")
    if (stato) this.#pubblica(stato.getAttribute("data-versioni-moduli-bloccate-value") === "true")
  }

  riprova() {
    const frame = this.element.closest("turbo-frame")
    if (!frame || !this.hasCaricamentoTarget) return
    frame.replaceChildren(this.caricamentoTarget.content.cloneNode(true))
    frame.reload()
  }

  aggiorna(event) {
    const form = event.target.closest?.("form")
    if (form && this.element.contains(form)) this.#aggiornaForm(form)
  }

  inizio(event) {
    const form = event.target
    form.dataset.versioniModuliOccupato = "true"
    const errore = form.querySelector("[id$='-errore']")
    if (errore) {
      errore.hidden = true
      errore.removeAttribute("role")
      errore.textContent = ""
    }
    form.querySelectorAll("select, textarea").forEach((campo) => { campo.disabled = true })
  }

  fine(event) {
    const form = event.target
    delete form.dataset.versioniModuliOccupato
    if (!this.element.contains(form)) return
    form.querySelectorAll("select, textarea").forEach((campo) => { campo.disabled = false })
    this.#aggiornaForm(form)
  }

  // onSaved: la risposta riuscita di una scheda (prima che lo stream la sostituisca) fa rileggere il frame del chiamante
  salvata(event) {
    const form = event.target
    if (!this.hasRefreshTargetValue || !(form instanceof HTMLFormElement) || !this.element.contains(form)) return
    if (!event.detail?.fetchResponse?.succeeded) return
    const frame = document.getElementById(this.refreshTargetValue)
    // dopo lo stream della risposta: la scheda salvata prima, poi la rilettura del frame
    if (frame?.reload) setTimeout(() => frame.reload(), 0)
  }

  #aggiornaForm(form) {
    const salva = form.querySelector("[data-versioni-moduli-salva]")
    if (!salva || form.dataset.versioniModuliOccupato) return
    const valore = (nome) => form.elements.namedItem(nome)?.value || ""
    salva.disabled = !!valore("doc_id") && (valore("motivo").trim().length < 10 || valore("fonte").trim().length < 10)
  }

  #pubblica(bloccate) {
    const pannello = this.element.closest("#application-prep-panel")
    if (!pannello) return
    pannello.dataset.blocked = String(bloccate)
    const run = pannello.querySelector("[data-testid='run-prepare-application-btn']")
    if (run) run.disabled = bloccate || run.dataset.bloccoPannello === "true"
  }

  #stessoIndirizzo(a, b) {
    if (!a || !b) return false
    return new URL(a, document.baseURI).href === new URL(b, document.baseURI).href
  }
}
